var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6655 13C17.6655 15.5768 15.5768 17.6655 13 17.6655C10.4232 17.6655 8.33447 15.5768 8.33447 13C8.33447 10.4232 10.4232 8.33447 13 8.33447C15.5768 8.33447 17.6655 10.4232 17.6655 13Z",
    fill: "url(#paint0_linear_330_10352)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4598 5.08662C23.2448 4.50403 22.9018 3.97669 22.4562 3.54385C22.0233 3.09816 21.4963 2.75517 20.9134 2.54017C20.4406 2.35655 19.7304 2.13798 18.4222 2.07844C17.0071 2.01391 16.5828 2 13.0002 2C9.41724 2 8.99295 2.01355 7.57817 2.07808C6.27 2.13798 5.55941 2.35655 5.08698 2.54017C4.50403 2.75517 3.97669 3.09816 3.5442 3.54385C3.09852 3.97669 2.75552 4.50367 2.54017 5.08662C2.35655 5.55941 2.13798 6.27 2.07844 7.57817C2.01391 8.99295 2 9.41724 2 13.0002C2 16.5828 2.01391 17.0071 2.07844 18.4222C2.13798 19.7304 2.35655 20.4406 2.54017 20.9134C2.75552 21.4963 3.09816 22.0233 3.54385 22.4562C3.97669 22.9018 4.50367 23.2448 5.08662 23.4598C5.55941 23.6438 6.27 23.8624 7.57817 23.9219C8.99295 23.9865 9.41688 24 12.9998 24C16.5831 24 17.0074 23.9865 18.4218 23.9219C19.73 23.8624 20.4406 23.6438 20.9134 23.4598C22.0836 23.0084 23.0084 22.0836 23.4598 20.9134C23.6435 20.4406 23.862 19.7304 23.9219 18.4222C23.9865 17.0071 24 16.5828 24 13.0002C24 9.41724 23.9865 8.99295 23.9219 7.57817C23.8624 6.27 23.6438 5.55941 23.4598 5.08662ZM13.0002 19.8897C9.19476 19.8897 6.10991 16.8052 6.10991 12.9998C6.10991 9.1944 9.19476 6.10991 13.0002 6.10991C16.8052 6.10991 19.8901 9.1944 19.8901 12.9998C19.8901 16.8052 16.8052 19.8897 13.0002 19.8897ZM20.1625 7.44768C19.2733 7.44768 18.5523 6.72674 18.5523 5.83751C18.5523 4.94828 19.2733 4.22735 20.1625 4.22735C21.0517 4.22735 21.7727 4.94828 21.7727 5.83751C21.7723 6.72674 21.0517 7.44768 20.1625 7.44768Z",
    fill: "url(#paint1_linear_330_10352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_10352",
    x1: 8.33447,
    y1: 13,
    x2: 17.6655,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_330_10352",
    x1: 2,
    y1: 13,
    x2: 24,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon1);
export default __webpack_public_path__ + "static/media/features-icon-1.f5c98e1349f9e5a9096c74ebd8db0a10.svg";
export { ForwardRef as ReactComponent };